module.exports = __webpack_public_path__ + "img/title-bg.e5c927fe.png";